import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["group"]

  connect() {
    this.switch()
  }

  switch() {
    const select = this.element.querySelector('[name="sf_task[record_type]"]')
    if (!select) return
    const selected = select.value

    this.groupTargets.forEach((group) => {
      const active = group.dataset.recordType === selected
      group.classList.toggle("d-none", !active)
      group.disabled = !active
      group.querySelectorAll("input, select, textarea").forEach((el) => {
        el.disabled = !active
      })
    })
  }
}
